const getMugshot = (agent_bio, width, deviceType = "") => {
  let final_photo;
  let original_photo = agent_bio.photo && agent_bio.photo.href ? agent_bio.photo.href : null;
  let final_width = deviceType === "mobile" ? width + "_q50" : width;

  if (
    original_photo &&
    original_photo.indexOf(".jpg") > -1 &&
    original_photo.indexOf("p.rdcpix.com") > -1
  ) {
    let url_without_ext = original_photo.split(".jpg")[0];
    final_photo = `${url_without_ext.slice(0, -1)}od-r7_w${final_width}.webp`;
  } else {
    final_photo = original_photo;
  }

  return final_photo;
};

const insertInImgUrl = (imgurl, txt, n) => {
  let a = imgurl;
  let b = txt;
  let position = imgurl && imgurl.length - n;
  let output = [a && a.slice(0, position), b, a && a.slice(position)]
    .join("")
    .replace("jpg", "webp");
  return output;
};
const removeHttpImageUrl = (imgurl) => {
  let imgurlMod = imgurl && imgurl.split("://")[1];
  let imgurlFinal = imgurlMod && "//" + imgurlMod;
  return imgurlFinal;
};

export { getMugshot, insertInImgUrl, removeHttpImageUrl };
